import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* globals google */
var GoogleMap = /*#__PURE__*/function () {
  function GoogleMap(id, settings) {
    var _this = this;

    _classCallCheck(this, GoogleMap);

    this.mapLayer = null;
    this.markers = []; // eslint-disable-next-line

    var initMap = new Promise(function () {
      var mapSettings = _objectSpread({
        mapTypeControlOptions: {
          mapTypeIds: ['roadmap']
        },
        mapTypeId: 'roadmap'
      }, settings);

      try {
        _this.mapLayer = new google.maps.Map(document.getElementById(id), mapSettings);
      } catch (err) {
        console.error(err.message);
      }
    });
    return this;
  }

  _createClass(GoogleMap, [{
    key: "removeStorePins",
    value: function removeStorePins(callback) {
      if (!window.google) {
        callback();
        return false;
      }

      if (this.markers && !this.markers.length) return false;

      for (var count = 0; count < this.markers.length; count += 1) {
        this.markers[count].setMap(null);
      }

      this.markers = [];
      return true;
    }
  }, {
    key: "addStorePin",
    value: function addStorePin(store) {
      var type = store.type,
          location = store.location; // eslint-disable-next-line no-nested-ternary

      var storeType = type === 0 ? 'red' : type === 1 ? 'orange' : 'black';
      var icon = {
        url: "//documents.4rgos.it/v1/static/icon-pin-".concat(storeType),
        scaledSize: new google.maps.Size(45, 45)
      };
      var marker = new google.maps.Marker({
        position: {
          lat: location.lat,
          lng: location.lng
        },
        map: this.mapLayer,
        icon: icon
      });
      this.markers.push(marker);
    }
  }, {
    key: "goToLocation",
    value: function goToLocation(lat, lng) {
      var zoom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;
      if (!this.mapLayer) return null;
      this.mapLayer.setZoom(zoom);
      this.mapLayer.setCenter({
        lat: lat,
        lng: lng
      });
      return true;
    }
  }]);

  return GoogleMap;
}();

export { GoogleMap as default };